import { useEffect, useState } from "react";
import { getEventDetails } from "../services/guest";
import { isEventExpired } from "../utils/eventUtils";

const useFetchSingleEventDetails = (eventId) => {
  const [eventDetails, setEventDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        setLoading(true);
        const data = await getEventDetails(eventId);
        setEventDetails(data);
        // Check if the event is expired
        setIsExpired(isEventExpired(data));
      } catch (error) {
        console.error("Error fetching event details", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchEventDetails();
  }, [eventId]);
  return { eventDetails, error, loading, isExpired };
};
export default useFetchSingleEventDetails;
